import { Logo } from '@arcadiapower/shrike';
import { ReactNode } from 'react';
import { OneColumnGrid } from '~/components/layout';
import { Link } from '~/components/link';
import { WEBSITE_URL } from '~/utils/constants';

export const Wrapper = ({ children, testId }: { children: ReactNode; testId: string }) => (
  <OneColumnGrid testId={testId} textAlign="center">
    <Link color="primary" href={WEBSITE_URL} openInNewTab justifyContent="center">
      <Logo scale={8} type="circle" variant="default" />
    </Link>
    {children}
  </OneColumnGrid>
);
